<!-- 轮播图Banner -->
<template>
  <van-swipe
    :lazy-render="false"
    class="banner-div"
    :autoplay="data.show_time || 3000"
    indicator-color="white"
  >
    <van-swipe-item v-for="(item, idx) in data.item" :key="idx">
      <div class="img-box">
        <img
          :src="$cvWebpFn(item.image, { w: 720 })"
          class="image"
          :lazy="useImgLazy().value"
          @click="$cmsStoreJump(
            item.type,
            item.data,
            {
              storeId,
              source: cmsSource
            }
          )"
        >
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script setup lang="ts">
import { buildStoreHomeListingSource, resolveStoreHomeSourceValue } from '@/plugins/utils'

const props = defineProps<{ storeId: number, data: IStore.IAdv }>()
const route = useRoute()

const cmsSource = computed(() =>
  buildStoreHomeListingSource(
    resolveStoreHomeSourceValue('advList', { checked_name: props.data.checked_name }),
    undefined,
    route
  )
)
</script>
<style lang='scss' scoped>
.banner-div {
  line-height: 0;
  background-color: white;
  .van-swipe-item {
    color: #fff;
    line-height: 0;
  }
}
.img-box{
  position: relative;
  height: 0;
  width: 100%;
  padding-bottom: 35.29%;
  .image{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border-radius: 10px;
    overflow: hidden;
    height: 100%;
    width: 100%;
  }
}
</style>